import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { Toaster } from 'sonner';

// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";


// Import scss
import "./assets/scss/theme.scss";


import { initLayoutFromStorage } from "./store/layout/actions";



const App = props => {
    
    // Initialize layout from localStorage on app load
    useEffect(() => {
        props.initLayoutFromStorage();
    }, []);

    function getLayout() {
        let layoutCls = VerticalLayout;
        switch (props.layout.layoutType) {
            case "horizontal":
                layoutCls = HorizontalLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    }

    const Layout = getLayout();
    return (
        <React.Fragment>
            <Router>
                <Switch>
                    {publicRoutes.map((route, idx) => (
                        <Authmiddleware
                            path={route.path}
                            layout={NonAuthLayout}
                            component={route.component}
                            key={idx}
                            isAuthProtected={false}
                            exact
                        />
                    ))}

                    <Route
                        path="/"
                        render={() => (
                            <Layout>
                                <Switch>
                                    {authProtectedRoutes.map((route, idx) => (
                                        <Authmiddleware
                                            path={route.path}
                                            component={route.component}
                                            key={idx}
                                            isAuthProtected={true}
                                            exact
                                        />
                                    ))}
                                </Switch>
                            </Layout>
                        )}
                    />
                </Switch>
            </Router>
            <Toaster
                position="top-center"
                richColors
                visibleToasts={1}
                duration={Infinity}
                closeButton
            />
        </React.Fragment>
    );
};

App.propTypes = {
    layout: PropTypes.any,
    initLayoutFromStorage: PropTypes.func
};

const mapStateToProps = state => {
    return {
        layout: state.Layout,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initLayoutFromStorage: () => dispatch(initLayoutFromStorage()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
